import { GlobalModal } from 'src/design-system'
import { X } from '@phosphor-icons/react'
import * as React from 'react'
import { observer } from 'mobx-react-lite'
import * as MegaModal from 'components/mega-modal'
import {
  CollectionsSection,
  FrameworksSection,
  GenerateWithAi,
  GetHelp,
  HelpSection,
  ReviewYourFramework,
  StartFromScratch,
} from './sections'
import { GetStartedModalButton } from './get-started-modal-button'
import { GetStartedVm } from './get-started-vm'
import { removeUrlParams } from '../../utils/url-helpers'

export const TITLE = 'Explore and create'

type GetStartedModalProps = {
  defaultOpen?: boolean
  className?: string
}

export const GetStartedModal = observer((props: GetStartedModalProps) => {
  const { defaultOpen = false, className } = props
  const [open, setOpen] = React.useState(defaultOpen)

  const vm = new GetStartedVm()

  React.useEffect(() => {
    const openGetStartedModalParam = 'open_get_started'
    const showGetStartedQueryParamPresent =
      Boolean(
        new URLSearchParams(window.location.search).get(
          openGetStartedModalParam,
        ),
      ) || undefined

    if (showGetStartedQueryParamPresent) setOpen(true)
    removeUrlParams(openGetStartedModalParam)
  }, [])

  return (
    <>
      <MegaModal.Root
        title={TITLE}
        // No h-auto here: MegaModal.Body scrolls with `overflow-y-auto h-full`,
        // and a percentage height needs a definite one above it. `h-auto` left
        // the height indefinite, so the body grew to its content while the
        // modal's own max-height still clipped the box — the content was cut
        // off with no scrollbar. Root's default h-[90vh] is the bound it wants.
        className="!max-w-[1170px]"
        open={open}
        onOpenChange={setOpen}
      >
        <MegaModal.Nav>
          <div className="flex flex-row justify-between items-center w-full">
            {TITLE}
            <GlobalModal.CloseButton className="flex items-center rounded-sm !outline-none focus:border focus:border-solid focus:!border-theme-60">
              <X weight="bold" className="text-gray-900 w-4 h-4" />
              <span className="sr-only">Close</span>
            </GlobalModal.CloseButton>
          </div>
        </MegaModal.Nav>
        <MegaModal.Body className="p-10" disableRightPane={true}>
          <header className="mb-10">
            <h2 className="font-bold text-gray-900 text-3xl mb-4">
              What would you like to do today?
            </h2>
            <p className="text-base text-gray-600">
              Everything you need to build and grow your frameworks, from
              ready-made templates to skill collections and help.
            </p>
          </header>
          <div className="flex flex-col gap-y-10">
            <div className="flex flex-col lg:flex-row gap-y-4 gap-x-10">
              {vm.showGenerateWithAi ? (
                <GenerateWithAi />
              ) : (
                <ReviewYourFramework />
              )}
              <StartFromScratch />
              <GetHelp />
            </div>
            <hr className="bg-gray-100 w-full m-0 border-0 h-px" />
            <div className="flex flex-col lg:flex-row gap-y-12 gap-x-10">
              <CollectionsSection />
              <FrameworksSection />
              <HelpSection />
            </div>
          </div>
        </MegaModal.Body>
      </MegaModal.Root>
      <GetStartedModalButton onOpenChange={setOpen} className={className} />
    </>
  )
})
